// Defensive patch: swallow NotFoundError when a node has already been removed
if (typeof Node !== 'undefined') {
  const originalRemoveChild = Node.prototype.removeChild;
  if (typeof originalRemoveChild === 'function') {
    Node.prototype.removeChild = function patchedRemoveChild(child) {
      try {
        return originalRemoveChild.call(this, child);
      } catch (err) {
        if (err && err.name === 'NotFoundError') {
          return child;
        }
        throw err;
      }
    };
  }
}

